// extracted by mini-css-extract-plugin
export var dropdown = "_va-0";
export var imageWrapper = "_va-3";
export var itemNameContainer = "_va-1";
export var productImage = "_va-2";
export var spinnerWrapper = "_va-4";